/** A square, not a circle: the design system is square-first. */
export function Spinner({ label }: { label?: string }) {
  return (
    <span className="inline-flex items-center gap-3 text-ink-mute" role="status">
      <span className="block size-3 animate-spin border border-brass" style={{ animationDuration: '1.4s' }} />
      {label && <span className="soc-label">{label}</span>}
    </span>
  )
}
